import { USER_JWT_TOKEN_COOKIE_NAME } from "./constants";
import {
  applyPriceOfferLoginOverride,
  resolvePostLoginPath,
} from "./postLogin";
import { useUserStore } from "~/stores/user";

export const LOGIN_REDIRECT_HOPS_COOKIE = "login-redirect-hops";
export const MAX_LOGIN_REDIRECT_HOPS = 2;
const LOGIN_REDIRECT_HOPS_WINDOW_SECONDS = 60;

/**
 * Sends a user who is already logged in on from the login page to where a
 * login would take them. Logged in means a verified session: the token cookie
 * the auth guard checks and a loaded `me`, so a stale or invalid token shows
 * the form instead.
 *
 * Loop guard: at most MAX_LOGIN_REDIRECT_HOPS redirects per
 * LOGIN_REDIRECT_HOPS_WINDOW_SECONDS. If the target keeps bouncing back to the
 * login page, the form is shown instead of redirecting forever.
 */
export function redirectAuthenticatedFromLoginMiddleware(context) {
  const { app, route, redirect, localePath, $helpers } = context;
  const userStore = useUserStore(context.$pinia);

  if (!userStore.me || !app.$cookie.get(USER_JWT_TOKEN_COOKIE_NAME)) {
    return;
  }

  const hops = Number(app.$cookie.get(LOGIN_REDIRECT_HOPS_COOKIE)) || 0;
  if (hops >= MAX_LOGIN_REDIRECT_HOPS) {
    return;
  }
  app.$cookie.set(LOGIN_REDIRECT_HOPS_COOKIE, String(hops + 1), {
    path: "/",
    maxAge: LOGIN_REDIRECT_HOPS_WINDOW_SECONDS,
  });

  applyPriceOfferLoginOverride({
    query: route.query,
    userStore,
    $cookie: app.$cookie,
    $helpers,
  });

  return redirect(
    resolvePostLoginPath({
      query: route.query,
      me: userStore.me,
      localePath,
      router: app.router,
    })
  );
}
